const PlayIcon = (props) => (
  <svg
    width={27}
    height={30}
    viewBox="0 0 27 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.98387 30C4.95029 30 3.93485 29.7221 2.99193 29.1662C1.1061 28.0544 0 26.0902 0 23.8666V6.13339C0 3.92833 1.12423 1.94565 2.99193 0.833849C4.87776 -0.27795 7.1081 -0.27795 8.9758 0.833849L24.0081 9.69117C25.8758 10.803 27 12.7856 27 14.9907C27 17.1958 25.8758 19.1785 24.0081 20.2903L8.9758 29.1476C8.03288 29.7221 7.01745 30 5.98387 30ZM5.98387 2.79802C5.42174 2.79802 4.85963 2.94624 4.35191 3.24272C3.33646 3.85421 2.71995 4.92894 2.71995 6.13339V23.8666C2.71995 25.071 3.33646 26.1458 4.35191 26.7573C5.36736 27.3502 6.60038 27.3687 7.61582 26.7573L22.6481 17.8999C23.6635 17.2884 24.2801 16.2137 24.2801 15.0093C24.2801 13.8048 23.6635 12.7301 22.6481 12.1186L7.61582 3.26127C7.1081 2.96479 6.54599 2.79802 5.98387 2.79802Z"
      fill="currentColor"
    />
  </svg>
);
export default PlayIcon;
